export function parseJwt(token: string): unknown | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const decoded = atob(base64);
    return JSON.parse(decoded);
  } catch (e) {
    return null;
  }
}

export function getRolesFromToken(token?: string): string[] {
  if (!token) {
    return [];
  }

  const payload = parseJwt(token) as { roles?: unknown } | null;
  if (!payload || !Array.isArray(payload.roles)) {
    return [];
  }

  return payload.roles.filter((r): r is string => typeof r === 'string');
}
